import { useSelector } from "react-redux";

export default function CancelQuitButton() {
    const queuePos = useSelector(state => state.liveAgent.queuePos);

    return (
        <div className="queue-container">
            <div>Your Queue Number is:</div>
            <div>{ queuePos }</div>
        </div>
    );
};
